import { jsx } from "react/jsx-runtime";
import { cva } from "../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Card.module.scss.js";
import CardBody from "./CardBody.js";
import CardHeader from "./CardHeader.js";
const cardVariants = cva(["bg-card-color rounded-lg"], {
  variants: {
    elevation: {
      "0": [styles["elevation-0"]],
      "1": ["shadow-sm", styles["elevation-1"]],
      "2": ["shadow", styles["elevation-2"]],
      "3": ["shadow-md", styles["elevation-3"]],
      "4": ["shadow-lg", styles["elevation-4"]],
      "6": ["shadow-xl", styles["elevation-6"]],
      "8": ["shadow-2xl", styles["elevation-8"]]
    }
  },
  defaultVariants: {
    elevation: "0"
  }
});
const _Card = (props, ref) => {
  const { children, as, elevation, className, ...rest } = props;
  const Component = as || "div";
  return /* @__PURE__ */ jsx(Component, { ...rest, ref, className: twMerge(cardVariants({ elevation, className })), children });
};
const Card = forwardRef(_Card);
Card.Header = CardHeader;
Card.Body = CardBody;
export {
  Card as default
};
//# sourceMappingURL=Card.js.map
